var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header'),_c('div',{staticClass:"side-nav"},[_c('Sidebar',{attrs:{"item":_vm.item,"payroll":_vm.payroll}})],1),_c('div',{staticClass:"main-content"},[_c('div',[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }